import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { throwErrorMessage } from "../../../../helpers/kwikui.common.helpers";
import { DEFAULT_VALUES, VALIDATE_KEY_VALUES } from "./stepper.constants";
import { TKwikUIStep, TKwikUIStepperOrientation } from "./stepper.definitions";
import { isValidKeyValue } from "./stepper.validation";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "kwikui-stepper",
  templateUrl: "./stepper.component.html",
  styleUrls: ["./stepper.component.scss"]
})
export class KwikUIStepperComponent implements OnInit, OnChanges {
  @Input() activeItemIndex: number = DEFAULT_VALUES.activeItemIndex;

  @Input() clickable: boolean = DEFAULT_VALUES.clickable;

  @Input() id: string = DEFAULT_VALUES.id;

  @Input() orientation: TKwikUIStepperOrientation = DEFAULT_VALUES.orientation;

  @Input() steps: Array<TKwikUIStep> = DEFAULT_VALUES.steps;

  @Output() onClick = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }
  }

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-stepper",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }
}
